import { render } from "./ProfileGraphBar.vue?vue&type=template&id=74bec72a"
import script from "./ProfileGraphBar.vue?vue&type=script&lang=js"
export * from "./ProfileGraphBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__